import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/**
 * The single API surface. Every feature injects its endpoints into this slice
 * so there is one cache, one set of tags and one place where auth failures are
 * handled.
 *
 * Response types come from src/api/generated (produced by `make types` from the
 * DRF schema). They are never hand-written alongside it.
 */

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/',
    credentials: 'include',
    prepareHeaders: (headers) => {
      const csrf = readCookie('csrftoken');
      if (csrf !== null) headers.set('X-CSRFToken', csrf);
      return headers;
    },
  }),
  tagTypes: [
    'Session',
    'Vehicle',
    'Driver',
    'RateCard',
    'Customer',
    'Enquiry',
    'Booking',
    'Availability',
    'Payment',
    'Invoice',
    // Anything the dues and revenue screens read. Taking a payment has to
    // change what both of them say.
    'Money',
    'Settings',
    'Attention',
  ],
  endpoints: () => ({}),
});
